import { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import WaitlistDialog from "@/components/WaitlistDialog";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/product", label: "Product" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 border-b border-border/70 backdrop-blur-xl bg-white/75"
    >
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 group">
          <div className="w-7 h-7 bg-[#002147] flex items-center justify-center">
            <span className="text-white font-mono text-[11px] tracking-tighter">CIQ</span>
          </div>
          <div className="leading-tight">
            <div className="font-serif text-lg">ContractIQ</div>
            <div className="text-[10px] font-mono tracking-[0.2em] uppercase text-muted-foreground -mt-0.5">by Cognita AI</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-mono tracking-[0.08em] uppercase transition-colors ${
                  isActive ? "text-foreground" : "text-muted-foreground hover:text-foreground"
                }`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="header-waitlist-btn"
            onClick={() => setWaitlistOpen(true)}
            className="hidden sm:inline-flex items-center px-5 py-2.5 bg-[#0A0A0A] text-white text-sm font-medium hover:bg-[#002147] transition-colors"
          >
            Join Waitlist
          </button>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2"
            aria-label="Toggle menu"
            onClick={() => setOpen((s) => !s)}
          >
            {open ? <X size={22} weight="regular" /> : <List size={22} weight="regular" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-white">
          <nav className="container-x py-4 flex flex-col gap-3" aria-label="Mobile">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-2 text-sm font-mono tracking-[0.1em] uppercase ${
                    isActive ? "text-foreground" : "text-muted-foreground"
                  }`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
            <button
              data-testid="mobile-waitlist-btn"
              onClick={() => { setWaitlistOpen(true); setOpen(false); }}
              className="mt-2 inline-flex items-center justify-center px-5 py-3 bg-[#0A0A0A] text-white text-sm font-medium"
            >
              Join Waitlist
            </button>
          </nav>
        </div>
      )}

      <WaitlistDialog open={waitlistOpen} onOpenChange={setWaitlistOpen} />
    </header>
  );
}
